import { useQuery } from '@tanstack/react-query';
import {
  DebtorConcentration,
  FundsConcentration,
} from 'pages/Home/components/Factoring/Wallet/components/Concentrations/types';
import { Dispatch } from 'redux';

import { requestHandler } from '../../api';

export const getDebtorConcentrations = (
  dispatch: Dispatch,
  startingDate: string,
) =>
  useQuery({
    queryKey: ['concentrations', 'debtor', startingDate],
    queryFn: async (): Promise<DebtorConcentration | undefined> => {
      const response = await requestHandler({
        method: 'get',
        url: `internal/concentrations/debtor?startingDate=${startingDate}`,
        dispatch,
      });
      if (response) return response.data;
    },
    enabled: !!startingDate,
    staleTime: 1000 * 60 * 60,
    gcTime: 1000 * 60 * 60 * 24,
    retry: 1,
  });

export const getFundsConcentrations = (
  dispatch: Dispatch,
  startingDate: string,
) =>
  useQuery({
    queryKey: ['concentrations', 'funds', startingDate],
    queryFn: async (): Promise<FundsConcentration | undefined> => {
      const response = await requestHandler({
        method: 'get',
        url: `internal/concentrations/funds?startingDate=${startingDate}`,
        dispatch,
      });
      if (response) return response.data;
    },
    enabled: !!startingDate,
    staleTime: 1000 * 60 * 60,
    gcTime: 1000 * 60 * 60 * 24,
    retry: 1,
  });
